import React from "react";
import { Input, Form } from "antd";
import { useForm } from "antd/es/form/Form";
import SAModal from "../../Common/Custom Components/Ant design/SAModal";
import CTConfigurationService from "../../Services/CTConfigurationService";
import { adminContext } from "../../Common/PageRoute";
import { Utils } from "../../Utilities/Utils";

const AddCompanyNames = ({ id, record, onDismiss, isViewOnly = false }: any) => {
    const [form] = useForm();
    const { openNotification } = React.useContext(adminContext);

    React.useEffect(() => {
        if (id !== undefined && id !== null && id !== "") {
            form.setFieldsValue({
                from: record?.from,
                to: record?.to,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    return (
        <>
            <SAModal
                title={`${id ? 'Edit' : 'Add'} Company Name`}
                footer={isViewOnly ? null : undefined}
                width={340}
                open={true}
                okText={"Save"}
                cancelText={"Cancel"}
                onOk={async () => {
                    let Id = id === undefined || id === null ? "" : id;
                    let values = undefined;
                    values = await form.validateFields().then(() => {
                        values = form.getFieldsValue();
                        return form.getFieldsValue();
                    }).catch((err) => { });

                    console.log("values", values);

                    if (!values?.from && !values?.to) {
                        openNotification("error", "Fill Atleast one field");
                    } else if (values !== undefined) {
                        let res = await CTConfigurationService.addCompanyNames(values, Id);
                        if (res.status) {
                            onDismiss(true);
                        } else {
                            openNotification(res.message);
                        }
                    }
                }}
                onCancel={() => {
                    onDismiss(false);
                }}
                okButtonProps={{ disabled: false }}
                cancelButtonProps={{ disabled: false }}
            >
                <Form form={form} disabled={isViewOnly} requiredMark={true}>
                    <Form.Item
                        className="custom-form-item"
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="From"
                        name="from"
                        rules={[{ validator: Utils.validateWhiteSpace }]}
                    >
                        <Input
                            placeholder="From"
                            className="line-height-28"
                            onChange={(e) => {
                                const value = e.target.value;
                                const capitalized = value.charAt(0).toUpperCase() + value.slice(1);
                                form.setFieldsValue({ name: capitalized });
                            }}
                        />
                    </Form.Item>
                    <Form.Item
                        className="custom-form-item"
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="To"
                        name="to"
                        rules={[{ validator: Utils.validateWhiteSpace }]}
                    >
                        <Input
                            placeholder="To"
                            className="line-height-28"
                            onChange={(e) => {
                                const value = e.target.value;
                                const capitalized = value.charAt(0).toUpperCase() + value.slice(1);
                                form.setFieldsValue({ name: capitalized });
                            }}
                        />
                    </Form.Item>
                </Form>
            </SAModal >
        </>
    );
};
export default AddCompanyNames;
